import { SiteEcomApi } from 'AiAssistantWidget/types';

export interface SiteEcomService {
  refreshCart(): Promise<void>;
}

export const createSiteEcomService = (ecom: SiteEcomApi): SiteEcomService => ({
  refreshCart() {
    return ecom.refreshCart();
  },
});
